import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'g-text-input',
  templateUrl: './g-text-input.component.html',
  styleUrls: ['./g-text-input.component.scss']
})
export class GTextInputComponent implements OnInit {
  static inputCounter = 0;
  @Input() control: FormControl;
  @Input() type?: string = 'text';
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() icon?: string = 'edit';
  @Input() name?: string;
  @Input() inputType?: string = 'primary';
  @Input() noFloat?: boolean = true;
  @Input() readyonly?: boolean;
  @Input() noAutocomplete?: boolean;
  @Output() newValue = new EventEmitter
  @Input() isInputFocused = false;



  constructor(private elementRef: ElementRef) { }
  ngOnInit(): void {
    if (!this.name) {
      this.name = "GTextInputComponent-" + GTextInputComponent.inputCounter.toString();
      GTextInputComponent.inputCounter++;
    }

  }
  onInputBlur() {

    this.isInputFocused = false;
  }
  onInputFocus() {

    this.isInputFocused = true;
  }

  inputChanged(event) {
    this.newValue.emit(event.target.value)

  }

  get isRequired() {
    const validator = this.control.validator({} as AbstractControl);

    if (validator && validator.required) {
      return true;
    }
  }
}

